import Vue from 'vue'

/**
 * @author Jose Luis R
 * @param payload
 * @return {Object}
 */

const rejectCP = payload =>
  Vue.$http.post(`purchase/reject_project/`, payload)
    .then(response => response.data)
export default rejectCP



// WEBPACK FOOTER //
// ./src/services/sinister/closeProject/rejectCP.js